// Recovered compiled webpack factory 22286. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  n.d(t, {
    GHOST_PILL_ACTION_LAYOUT: () => s,
    GHOST_PILL_BUTTON: () => u,
    GHOST_PILL_BUTTON_SECONDARY: () => d,
    GHOST_PILL_CLOSE: () => f,
    GHOST_PILL_TEXT_LAYOUT: () => l,
    default: () => h,
  });
  var r = n(95155),
    i = n(12115),
    a = n(18720);
  function o(e) {
    let { children: t } = e,
      n = (0, i.useRef)(null);
    return (
      (0, i.useLayoutEffect)(() => {
        var e;
        let t = null == (e = n.current) ? void 0 : e.closest("[data-sonner-toast]"),
          r = null == t ? void 0 : t.closest("[data-sonner-toaster]");
        if (!t || !r) return;
        let i = () => r.style.setProperty("--um-bottom-toast-height", `${t.offsetHeight}px`);
        i();
        let a = new ResizeObserver(i);
        return (a.observe(t), () => a.disconnect());
      }, []),
      (0, r.jsx)("div", { ref: n, className: "contents", children: t })
    );
  }
  let s = "inline-flex items-center gap-3 pl-4 pr-1.5 py-1.5",
    l = "inline-flex items-center gap-3 px-4 py-2.5",
    c =
      "shrink-0 inline-flex items-center justify-center h-[24px] px-3 rounded-[7px] text-[12px] font-medium leading-none whitespace-nowrap cursor-pointer transition-colors",
    u = `${c} bg-[#fd631f] text-white hover:bg-[#ff7a3d] active:bg-[#e8560f]`,
    d = `${c} bg-white/[0.08] text-white/85 hover:bg-white/[0.14] active:bg-white/[0.06]`,
    f =
      "shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-[7px] text-white/50 hover:text-white hover:bg-white/[0.08] cursor-pointer transition-colors",
    m = { default: "", accent: "um-ghost-accent" };
  function h(e) {
    let {
        children: t,
        onDismiss: n,
        dismissOnEscape: s = !1,
        innerClassName: c = l,
        variant: u = "default",
        beam: d = !1,
        className: f,
        role: h = "status",
        ariaLabel: p,
        pinToBottom: g = !1,
      } = e,
      v = (0, i.useId)(),
      w = (0, i.useRef)(!1),
      b = (0, i.useRef)(n);
    b.current = n;
    let y = (0, i.useCallback)(() => {
        var e;
        w.current || ((w.current = !0), a.toast.dismiss(v), null == (e = b.current) || e.call(b));
      }, [v]),
      _ = (0, i.useCallback)(() => {
        var e;
        w.current || ((w.current = !0), null == (e = b.current) || e.call(b));
      }, []),
      x = null != n;
    (0, i.useEffect)(() => {
      w.current ||
        a.toast.custom(
          () =>
            (0, r.jsx)("div", {
              role: h,
              "aria-label": p,
              className: `${c}${d ? " um-beam um-beam-on squircle-xl" : ""}`,
              children: g
                ? (0, r.jsx)(o, { children: "function" == typeof t ? t({ dismiss: y }) : t })
                : "function" == typeof t
                  ? t({ dismiss: y })
                  : t,
            }),
          {
            id: v,
            duration: 1 / 0,
            dismissible: x,
            onDismiss: x ? _ : void 0,
            className: ["um-ghost-custom", m[u], g && "um-ghost-bottom-anchor", f]
              .filter(Boolean)
              .join(" "),
          },
        );
    });
    let S = (0, i.useRef)(null);
    return (
      (0, i.useEffect)(
        () => (
          null != S.current && (window.clearTimeout(S.current), (S.current = null)),
          () => {
            S.current = window.setTimeout(() => {
              ((S.current = null), a.toast.dismiss(v));
            }, 0);
          }
        ),
        [v],
      ),
      (0, i.useEffect)(() => {
        if (!s) return;
        let e = (e) => {
          "Escape" === e.key && y();
        };
        return (
          window.addEventListener("keydown", e),
          () => window.removeEventListener("keydown", e)
        );
      }, [s, y]),
      null
    );
  }
}
